export default __webpack_public_path__ + "static/screenshot-b031f9c3d04026c7390ed0083981b102.png";